"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "oderzo": {
    "5ffc57d7": [{
      "hkey": "2f740b71",
      "slug": "camino-zona-industriale",
      "name": "Camino-Zona Industriale",
      "primary": true,
      "skipSearch": false
    }],
    "camino": [{
      "hkey": "2f740b71",
      "slug": "camino-zona-industriale",
      "name": "Camino-Zona Industriale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "bf601c9c": [{
      "hkey": "18b12860",
      "slug": "oderzo",
      "name": "Oderzo",
      "primary": true,
      "skipSearch": false
    }],
    "san-vincenzo": [{
      "hkey": "18b12860",
      "slug": "oderzo",
      "name": "Oderzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;